<template>
<div class="main home" id="bannerlist">
    <div class="home-box">
        <h1>Banner管理</h1>
        <div class="home-content">
            <search-item :searchInfo.sync="info" @searchList="searchList" @addBanner="addBanner"></search-item>
            <!-- 表格 -->
            <div class="table_container" style="margin-top:10px;">
                <el-table border :data="tableData" stripe v-loading="tableLoading" style="width: 100%" align='center'>
                    <el-table-column prop="bannerName" label="banner名称" align='center'>
                    </el-table-column>
                    <el-table-column prop="url" label="跳转链接/课程" align='center'>
                    </el-table-column>
                    <el-table-column prop="bannerPosition" width="120" label="banner位置" align='center'>
                    </el-table-column>
                    <el-table-column prop="name" width="120" label="banner类型" align='center'>
                        <template slot-scope="scope">
                            {{scope.row.bannerType == 1 ? '课程' : '第三方'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" width="220" label="添加时间" align='center'>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleUpdate(scope.row)" type="text" size="small">修改</el-button>
                            <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination :paginationInfo="paginationInfo" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"></pagination>
            </div>
        </div>
    </div>
    <el-dialog :append-to-body='true' title="添加/修改Banner图" :visible.sync="showDialog" width="34%">
        <el-form ref="form" label-width="150px">
            <el-form-item label="banner名称" required>
                <el-input v-model="bannerData.bannerName" clearable></el-input>
            </el-form-item>
            <el-form-item label="banner位置" required>
                <el-input v-model="bannerData.bannerPosition" type="number"></el-input>
            </el-form-item>
            <el-form-item label="banner类型" required>
                <el-radio v-model="bannerData.bannerType" label='1'>课程</el-radio>
                <el-radio v-model="bannerData.bannerType" label="2">第三方</el-radio>
            </el-form-item>
            <el-form-item :label="bannerData.bannerType == '1' ? '跳转课程' : '跳转链接'" required>
                <el-autocomplete v-if="bannerData.bannerType == '1'" style="width:100% !important" v-model="bannerData.url" :fetch-suggestions="querySearchAsync" @select="handleSelect" placeholder="如类型选择课程，将模糊检索课程名称"></el-autocomplete>
                <el-input v-else v-model="bannerData.url" @input="saveurl" placeholder="如类型选择课程，将模糊检索课程名称"></el-input>
            </el-form-item>
            <el-form-item label="banner图">
                <el-upload list-type="picture-card" :limit='1' :on-preview="handlePictureCardPreview" :on-remove="handleRemove" accept=".jpg,.jpeg,.png" :action="fileUploads.actionUrl" :headers="fileUploads.authToken" :before-upload="beforeUploadEvidenceMenu" :on-success="sendEvidenceMenu" :file-list="bannerfile">
                    <i slot="default" class="el-icon-plus"></i>
                </el-upload><span style="margin-left:20px;color:#e8403d;">*&nbsp;&nbsp;一次只允许上传一张banner图，推荐尺寸900 * 380</span>
                <el-dialog :modal-append-to-body='false' title="banner预览" :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" round @click="onSubmit">提交</el-button>
                <el-button round @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</div>
</template>

<script>
import Pagination from "@/components/pagination";
import SearchItem from "./searchItem";
export default {
    data() {
        return {
            // 表格loading
            tableLoading: true,
            tableData: [], //表格数据
            paginationInfo: {
                pageIndex: 1, // 当前位于哪页
                pageTotal: 0, //表格总页数
                pageSize: 10, //每页显示条数
                pageSizes: [5, 10, 15, 20], //每页显示个数选择器的选项设置
                layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
            },
            pidList: [],
            centerDialogVisible: false,
            registerId: "",
            info: {
                name: ""
            },
            activeName: '0',
            showDialog: false,
            bannerData: {
                bannerName: '',
                bannerPosition: 0,
                bannerType: '1',
                courseId: '',
                bannerUrl: '',
                url: ''
            },
            editState: false,
            bannerDialogVisible: false,
            dialogImageUrl: '',
            fileUploads: {
                actionUrl: process.env.VUE_APP_BASE_API + '/api/file/upload',
                authToken: {
                    JWTToken: sessionStorage.getItem('token'),
                    ctype: 'PC'
                }
            },
            bannerfile: [],
            dialogVisible: false,
            restaurants: [],
            timeout: null,
            allCourseList: []
        }
    },
    mounted() {
        let that = this
        this.getBannerList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
        this.getAllCourseList()
    },
    methods: {
        //  获取表格信息
        getBannerList(currpage, pageSize, info) {
            console.log(info)
            this.tableLoading = true;
            let params = {
                pageNumber: currpage,
                pageSize: pageSize,
                keyWords: info ? info.name : ''
            }
            this.tableData = []
            console.log(params)
            this.$api.getBannerList(params).then(res => {
                console.log('000', res)
                this.tableLoading = false;
                if (res && res.status == "OK") {
                    this.paginationInfo.pageTotal = parseInt(res.data.total)
                    this.paginationInfo.pageIndex = res.data.pageNum
                    this.tableData = res.data.pageList
                } else {
                    this.tableLoading = false;
                    this.$message.error(res.errorMsg)
                }
            }).catch(error => {
                console.log(error)
                this.tableLoading = false;
            })
        },
        searchList(e) {
            console.log(e)
            this.info = e
            this.getBannerList(1, this.paginationInfo.pageSize, e)
        },
        // 上下分页
        handleCurrentChange(val) {
            // console.log('上下分页',val)
            let that = this
            this.paginationInfo.pageIndex = val
            this.getBannerList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
        },
        // 每页显示多少条
        handleSizeChange(val) {
            // console.log('每页显示多少条',val)
            let that = this
            this.paginationInfo.pageSize = val
            this.getBannerList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
        },
        submitDialog(e) {
            this.registerId = e.registerId
            this.centerDialogVisible = true
        },
        onSubmit() {
            let that = this
            if (this.bannerData.bannerName.toString().trim() == "") {
                this.$message.warning('请输入banner图名称')
                return
            }
            if (this.bannerData.bannerPosition.toString().trim() == "") {
                this.$message.warning('请输入banner位置')
                return
            }
            if (this.bannerData.bannerType != '1') {
                this.bannerData.courseId = ''
            }
            if (this.bannerData.url.toString().trim() == "") {
                this.$message.warning(`请输入跳转${this.bannerData.bannerType == '1' ? '课程' : '链接'}`)
                return
            }
            if (this.bannerfile.length === 0) {
                this.$message.warning('请上传banner图')
                return
            } else {
                this.bannerData.bannerUrl = this.bannerfile[0].url
            }

            if (this.editState) {
                this.$api.updateBanner(this.bannerData).then(res => {
                    if (res.status == "OK") {
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.showDialog = false
                        this.bannerData = {
                            bannerName: '',
                            bannerPosition: 0,
                            bannerType: '1',
                            courseId: '',
                            bannerUrl: '',
                            url: ''
                        }
                        this.editState = false
                        this.getBannerList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
                    } else {
                        this.$message.error(res.errorMsg)
                    }
                })
            } else {
                this.$api.saveBanner(this.bannerData).then(res => {
                    if (res.status == "OK") {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.bannerdata = {
                            bannerName: '',
                            bannerPosition: 0,
                            bannerType: '1',
                            courseId: '',
                            bannerUrl: '',
                            url: ''
                        }
                        this.showDialog = false
                        this.editState = false
                        this.getBannerList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
                    } else {
                        this.$message.error(res.errorMsg)
                    }
                })
            }
        },
        handleUpdate(e) {
            this.showDialog = true
            this.bannerData = {
                bannerId: e.bannerId,
                bannerName: e.bannerName,
                bannerPosition: e.bannerPosition,
                bannerType: e.bannerType.toString(),
                courseId: e.courseId,
                bannerUrl: e.bannerUrl,
                url: e.url
            }
            this.bannerfile = [{
                name: '',
                url: e.bannerUrl
            }]
            this.editState = true
        },
        addBanner() {
            this.bannerData = {
                bannerName: '',
                bannerPosition: 0,
                bannerType: '1',
                courseId: '',
                bannerUrl: '',
                url: ''
            }
            this.bannerfile = []
            this.showDialog = true
        },
        close() {
            this.showDialog = false
        },
        del(e) {
            let that = this
            this.$confirm('确定要删除该banner图?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.delBanner({
                    bannerId: e.bannerId
                }).then(res => {
                    if (res.status == "OK") {
                        this.getBannerList(that.paginationInfo.pageIndex, that.paginationInfo.pageSize, that.info)
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                    } else {
                        this.$message({
                            type: 'error',
                            message: '删除失败'
                        });
                    }
                })
            }).catch(() => {});
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        handleRemove(file) {
            console.log(file);
            this.bannerfile = []
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        beforeUploadEvidenceMenu(file) {
            console.log(file)
            if (['image/png', 'image/jpg', 'image/jpeg'].every(item => item != file.type)) {
                this.$message.error('仅支持png、jpg、jpeg格式的文件!');
                return false
            }
            const isLt = file.size / 1024 / 1024 < 10;
            if (!isLt) {
                this.$message.error('上传图片不能超过10M');
                return false
            }
            if (this.bannerfile.length == 1) {
                this.$message.error('每次新增或编辑只允许上传一张banner图');
                return false
            }
        },
        sendEvidenceMenu(response, file, fileList) {
            console.log('----上传文件----', response, file)
            if (this.bannerfile.length > 1) {
                this.$message.error('每次新增或编辑只允许上传一张banner图');
                return false
            }
            this.bannerfile.push({
                url: response.data,
                name: file.name
            })
        },
        querySearchAsync(queryString, cb) {
            let restaurants = this.allCourseList;
            let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                console.log(results)
                cb(results);
            }, 3000 * Math.random());
        },
        createStateFilter(queryString) {
            return (item) => {
                return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
            };
        },
        handleSelect(item) {
            console.log(item.courseId);
            this.bannerData.courseId = item.courseId
        },
        getAllCourseList() {
            this.$api.getCoursebyBanner({
                keyWords: ''
            }).then(res => {
                if (res.status == 'OK') {
                    this.allCourseList = res.data
                    this.allCourseList.map(n => {
                        n.value = n.courseName
                    })
                }
            })
        },
        saveurl(e) {
            console.log(e)
            this.bannerData.url = e
        }
    },
    components: {
        Pagination,
        SearchItem
    }
}
</script>

<style>
/* 标题 */
.menu .title1 img {
    top: 22px;
}

.menu .title1 h3 {
    font-size: 20px;
    margin-top: -14px;
}

/* 分页 */
.el-pagination button,
.el-pagination span:not([class*=suffix]) {
    padding: 0 10px;
}

.home .block-title {
    width: 100%;
    padding: 0 0 28px 20px;
    display: flex;
    align-items: center;
}

.home .block-title h3 {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
}

.home .a-text {
    text-decoration: underline;
    color: #1e61ce;
}

.home .block-title .btn {
    width: 180px;
    height: 35px;
    background-color: #1e61ce;
    border-radius: 20px;
    margin-left: 20px;
    font-weight: normal;
    font-stretch: normal;
    color: #ffffff;
    padding: 0;
}

.home .btn span {
    font-size: 16px !important;
    color: #fff !important;
}

.home .block-title span {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #63717A;
}

.home .top {
    width: 100%;
    padding: 0 0 10px 0;
    border-radius: 10px;
    background: #fefefe;
}

.home .top .title {
    width: 100%;
    height: 90px;
    line-height: 90px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
    font-family: PingFangSC-Semibold;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
    border-bottom: 1px solid #f2f3f5;
}

.home .el-col {
    border-radius: 10px;
}

.home .grid-content {
    border-radius: 10px;
    /* min-height: 36px; */
}

.home .leftInfo {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}

.home .leftInfo .headPic {
    width: 165px;
    height: 165px;
    border-radius: 100%;
    border: 8px solid #fff;
    position: relative;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    box-shadow: 0px 12px 30px 0px rgba(6, 37, 117, 0.12);
}

.home .leftInfo .headPic img {
    width: 100%;

}

.home .rightInfo {
    margin-top: 10px;
    padding-right: 10px;
}

.home .rightInfo .name-text {

    margin-bottom: 20px;
    font-family: PingFangSC-Semibold;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #2d3039;
}

.home .rightInfo .info-text img {
    width: 26px;
    height: 26px;
    margin-right: 20px;
}

.home .rightInfo .info-text {
    margin-bottom: 20px;
    font-family: PingFangSC-Medium;
    font-size: 18px;
    letter-spacing: 0px;
    color: #63717a;
    display: flex;
    /* justify-content: center; */
    align-items: center;
    text-align: left
}

.home .rightInfo .info-text h1 {
    font-size: 20px;
    font-weight: 600;
    font-family: PingFangSC-Medium;
    color: #2d3039;
    margin-left: 10px;
    display: block;
    font-size: 90.5%;
}

.home .middle {
    width: 100%;
    border-radius: 10px;
}

.home .middle .grid-content {
    background: #fff
}

.home .title1 {
    width: 100%;
    display: flex;
    padding: 0 20px 20px 20px;
    align-items: center;
    margin-top: -10px;
    border-bottom: 1px solid #f2f3f5;
}

.home .title1 h3 {
    font-size: 20px;
    margin-top: -10px;
}

.home .title1 img {
    position: relative;
    top: 18px;
    margin-right: 10px;
}

.home .ajs-Title {
    margin-left: 20px;
}

.home .ajs {
    margin-left: 20px;
    color: #0033cf;
}

.home .left-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    /* border-right: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8; */
}

.home .right-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
}

.home .main-block {
    height: 200px;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #d8d8d8;
}

.home .labelModule {
    background: #F2F5FA;
    border: 1px solid #D6E0F0;
    border-radius: 10px;
    display: inline-block;
    width: 100%;
    padding: 20px;
}

.home .labelModule:first-child {
    margin-bottom: 20px;
}

.home .labelModule ul li {
    width: 100%;
    font-size: 16px;
    color: #63717A;
    text-align: center
}

.home .labelModule ul li:first-child {
    margin-bottom: 10px;
}

.home .labelModule ul li font {
    font-size: 41px;
    color: #2D3039;
}

/*公共部分 hmm*/
.p20 {
    padding: 20px;
}

.pb30 {
    padding-bottom: 30px;
}

/*办案类型 数据超出 显示样式 hmm 090404*/

.widthBig .labelModule {
    width: 49.2%;
}

.widthBig .labelModule:first-child {
    margin-bottom: 30px;
    margin-right: 20px;
}

.widthSmall {
    float: right;
}

.rs-block {
    width: 98%;
    height: 80px;
    text-align: right;
    line-height: 80px;
}

#bannerlist .el-input {
    width: 80%;
}
</style>
